"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _Gallery = require("b2b-components/core/components/Gallery");
var _image = require("b2b-components/theme/components/Gallery/utils/image");
var _FallbackItem = require("../FallbackItem");
var _Item = require("../Item");
const ImageItem = _ref => {
  let {
    image,
    isCurrentImage,
    imageUrl,
    itemIndex,
    text,
    title,
    className,
    isPreview,
    isCurrent,
    onClick,
    totalItemCount,
    href,
    imageDisclaimer
  } = _ref;
  const autostart = isCurrentImage ? 'autostart: true' : 'autostart: false';
  if (!image[_image.IMAGE_SIZE.full]) {
    return /*#__PURE__*/_react.default.createElement(_FallbackItem.FallbackItem, {
      title: title
    });
  }
  return /*#__PURE__*/_react.default.createElement(_Item.Item, {
    className: className,
    isPreview: isPreview,
    isCurrent: isCurrent,
    onClick: onClick,
    totalItemCount: totalItemCount,
    href: href,
    type: _Gallery.GALLERY_ITEM_TYPE.image,
    imageDisclaimer: imageDisclaimer
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "MagicZoom",
    "data-mobile-options": `textClickZoomHint: ${text.zoomHintMobile}`,
    "data-options": `${autostart}
          hint: always;
          lazyZoom: true;
          textClickZoomHint: ${text.zoomHint};
          zoomOn: click;
          zoomPosition: inner;`,
    href: (0, _image.getImageSrc)(image, imageUrl, _image.IMAGE_SIZE.full),
    id: `image${itemIndex || 0}`,
    onClick: e => e.preventDefault()
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: (0, _image.getImageSrc)(image, imageUrl, _image.IMAGE_SIZE.preview),
    title: title,
    alt: title
  })));
};
exports.ImageItem = ImageItem;
//# sourceMappingURL=ImageItem.js.map